const middleware = {}

middleware['checkuser'] = require('..\\middleware\\checkuser.js')
middleware['checkuser'] = middleware['checkuser'].default || middleware['checkuser']

export default middleware
